// extracted by mini-css-extract-plugin
export default {"root":"styles_root__BH5qi","svg":"styles_svg__Dq3P4"};